import type { VoidFunctionComponent } from 'react';

import type { GroupedTerms } from '../types';

import TermSection from './TermSection';

import styles from '../LicenseDrawer.module.less';

type Props = {
  groupedTerms: GroupedTerms;
};

const ObligationTab: VoidFunctionComponent<Props> = ({ groupedTerms }) => {
  return (
    <>
      <div className={styles.title}>Obligations</div>
      <div className={styles.summary}>
        <div className={styles.obligationDescription}>
          License obligations are the duties and responsibilities a licensee (the party receiving the license) must
          fulfill as outlined in a licensing agreement. These obligations ensure the licensee uses the licensed property
          (like software, trademarks, or real estate) according to the agreement&apos;s terms and conditions.
        </div>
        <TermSection title="You Must" icon="exclamationCircleRegular" terms={groupedTerms.MUST} />
      </div>
    </>
  );
};

export default ObligationTab;
